import axios from "axios";

// IMPORTANT: API calls must be SAME-ORIGIN so the auth cookie is first-party.
// When the app is served on a custom domain (e.g. joinwanted.com) or the preview
// domain, the Kubernetes ingress already routes `/api/*` to the backend on that
// same host. Using the current browser origin guarantees cookies persist across
// signup → /auth/me → all subsequent requests on every deployment.
const BROWSER_ORIGIN =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : "";

// Fallback for non-browser contexts (e.g. SSR/build-time). Never used at runtime
// in the browser, so it cannot cause cross-origin cookie loss in production.
const BACKEND_URL = BROWSER_ORIGIN || process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => `${API}/files/${path}`;
